/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolTokenIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-token"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M9.05 8.85Q9.63 8.3 10.38 7.99Q11.13 7.67 12 7.67Q12.88 7.67 13.63 7.99Q14.38 8.3 14.95 8.85L19.98 6.05L13.28 2.35Q12.68 2 12 2Q11.32 2 10.72 2.35L4.03 6.05ZM10.68 21.63L10.68 16.13Q9.35 15.7 8.51 14.57Q7.67 13.45 7.67 12Q7.67 11.78 7.69 11.56Q7.7 11.35 7.75 11.15L2.67 8.32L2.67 15.63Q2.67 16.35 3.04 16.98Q3.4 17.6 4.05 17.95ZM12 13.68Q12.7 13.68 13.19 13.19Q13.68 12.7 13.68 12Q13.68 11.3 13.19 10.81Q12.7 10.32 12 10.32Q11.3 10.32 10.81 10.81Q10.32 11.3 10.32 12Q10.32 12.7 10.81 13.19Q11.3 13.68 12 13.68ZM13.32 21.63L19.95 17.95Q20.6 17.6 20.96 16.98Q21.32 16.35 21.32 15.63L21.32 8.32L16.25 11.15Q16.3 11.35 16.31 11.56Q16.32 11.78 16.32 12Q16.32 13.45 15.49 14.57Q14.65 15.7 13.32 16.13Z" fill={color} />
    </svg>
  );
}
